import { setAvailableRoutes } from './reducer';
import { http } from '../../Lib/Http/httpClient';
export function getAvailableRoutes(roleId) {
    return function (dispatch) {
        return http.client.get('/routes/getAvailable/' + roleId).then(function (response) {
            dispatch(setAvailableRoutes(response.data.data));
        });
    };
}
